const colorHexCodeRegex = /^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/

const slugRegex = /^[a-z0-9]+([-_]([a-z0-9]+))*$/

const subdomainRegex = /^[a-z0-9]+(-[a-z0-9]+)*$/

const domainRegex = /^$|^(((?!-))(xn--|_)?[a-z0-9-]{0,61}[a-z0-9]{1,1}\.)*(xn--)?([a-z0-9][a-z0-9\-]{0,60}|[a-z0-9-]{1,30}\.[a-z]{2,})$/

export { colorHexCodeRegex, slugRegex, subdomainRegex, domainRegex }